import { Flex, Label, Tag, Text } from '@approvalmax/ui/src/components';
import { clsx } from 'clsx';
import { ComponentType, memo, MemoExoticComponent, useCallback } from 'react';

import { accountParams } from './NewBankAccountCard.constants';
import { Loading } from './NewBankAccountCard.loading';
import { messages } from './NewBankAccountCard.messages';
import { AccountParams, Root } from './NewBankAccountCard.styles';
import type { ChildrenComponents, NewBankAccountCardProps } from './NewBankAccountCard.types';

export const NewBankAccountCard = memo<NewBankAccountCardProps>((props) => {
    const { id, logoImage, nickname, matched, selected, onClick } = props;

    const handleClick = useCallback(() => {
        onClick(id);
    }, [id, onClick]);

    return (
        <Root
            role='listitem'
            tabIndex={0}
            data-testid={`bank-account-${id}`}
            // we need `checked` class to remove bottom-border from the previous sibling
            className={clsx(selected && 'selected')}
            $checked={selected}
            onClick={handleClick}
        >
            <Flex direction='column' spacing='8'>
                <Flex spacing='8' alignItems='center'>
                    {logoImage}

                    <Flex grow={1}>
                        <Text font='label' fontSize='medium' fontWeight='regular' color='midnight80'>
                            {nickname}
                        </Text>
                    </Flex>

                    {matched && (
                        <Tag color='green100' size='xsmall' title={messages.matched}>
                            {messages.matched}
                        </Tag>
                    )}
                </Flex>

                <AccountParams>
                    {accountParams
                        .filter((prop) => props[prop])
                        .map((prop) => (
                            <div key={prop}>
                                <Label size='xsmall'>{messages[prop]}</Label>

                                <Text font='label' fontSize='small' color='midnight100'>
                                    {props[prop]}
                                </Text>
                            </div>
                        ))}
                </AccountParams>
            </Flex>
        </Root>
    );
}) as MemoExoticComponent<ComponentType<NewBankAccountCardProps>> & ChildrenComponents;

NewBankAccountCard.displayName = 'NewBankAccountCard';

NewBankAccountCard.Loading = Loading;
